import {Pipe} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';

@Pipe({name: 'BackofficeCurrency'})
export class BackofficeCurrencyPipe extends TranslatePipe {

  constructor(
    private cookieService: CookieService,
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef
  ) {
    super(translateService, changeDetectorRef);
  }

  transform(value) {
    const thousandSeparator = this.cookieService.check('thousandSeparator') ? this.cookieService.get('thousandSeparator') : '.';
    const decimalSeparator = this.cookieService.check('decimalSeparator') ? this.cookieService.get('decimalSeparator') : ',';
    const currencyDecimals = this.cookieService.check('currencyDecimals') ? this.cookieService.get('currencyDecimals') : 2;
    return (parseFloat(value) === 0 || value === null) ? '-' : super.transform('global.currency_sign') + ' ' + this.number_format(value, currencyDecimals, decimalSeparator, thousandSeparator);
  }

  private number_format(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    let n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? '.' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? ',' : dec_point,
      toFixedFix = function (n, prec) {
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        let k = Math.pow(10, prec);
        return Math.round(n * k) / k;
      },
      s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  }
}
